import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { useFirebase } from "../../../context/Firebase";
import { CircularProgress, Button, Box, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import "./Jobdetail.css";

const JobDetails = () => {
  const { id } = useParams();
  const { db } = useFirebase();
  const navigate = useNavigate();

  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJob = async () => {
      setLoading(true);
      setError(null);
      try {
        const docRef = doc(db, "jobs", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setJob(docSnap.data());
        } else {
          setError("Job not found");
        }
      } catch (err) {
        setError("Failed to load job details.");
      } finally {
        setLoading(false);
      }
    };
    fetchJob();
  }, [db, id]);

  if (loading)
    return (
      <Box className="job-details-loader" display="flex" justifyContent="center" alignItems="center" height="60vh">
        <CircularProgress />
      </Box>
    );

  if (error)
    return (
      <Box className="job-details-error-container" textAlign="center" mt={8} px={2}>
        <Typography variant="h6" color="error" gutterBottom>{error}</Typography>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );

  return (
    <Box className="job-details-container" maxWidth="900px" mx="auto" px={{ xs: 2, sm: 4 }} py={{ xs: 3, sm: 5 }} sx={{ bgcolor: 'var(--card-bg)', borderRadius: '12px', boxShadow: '0 6px 20px rgba(0,0,0,0.1)', color: 'var(--text-primary)' }}>
      <Button
        variant="outlined"
        onClick={() => navigate(-1)}
        sx={{
          mb: 3,
          width: { xs: "100%", sm: "auto" },
          whiteSpace: "nowrap",
        }}
      >
        ← Back 
      </Button>

      <Typography
        variant="h4"
        component="h1"
        mb={3}
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.8rem", sm: "2.4rem" },
          wordBreak: "break-word",
        }}
      >
        {job.title}
      </Typography>

      {job.imageUrl && (
        <Box
          component="img"
          src={job.imageUrl}
          alt={job.title}
          sx={{
            width: "100%",
            maxHeight: { xs: 250, sm: 420 },
            objectFit: "cover",
            borderRadius: "12px",
            mb: 4,
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
          }}
        />
      )}

      <Box
        sx={{
          fontSize: { xs: "1rem", sm: "1.1rem" },
          lineHeight: 1.7,
          color: "var(--text-secondary)",
          whiteSpace: "pre-line",
          wordBreak: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.description || "") }}
      />
    </Box>
  );
};

export default JobDetails;
